<template>
  <modal
    class="addNewRetainershipModal"
    name="downloadReportModal"
    transition="pop-out"
    :width="modalWidth"
    :height="550"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closeDownloadReportModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.companyRetainership.downloadReport") }}
        </h3>

        <div class="sign_up_form_section">
          <div class="">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :custom-shortcuts="customShortcuts"
              color="#4b2d73"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
              class="border"
            />
          </div>
          <div class="text-center mt-5">
            <button
              style="background-color: #46266e"
              class="add_quick_fuel_btn"
              @click="downloadReport"
            >
              {{ $t("text.companyRetainership.generate") }} <span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "RetainershipModal",
  props: ["company"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,

      isButtonDisabled: false,
      // dateRange

      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(90, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      //
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
      }
    },
  },
  methods: {
    closeDownloadReportModal() {
      this.$modal.hide("downloadReportModal");
    },

    downloadReport() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/DownloadReport/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?start=${this.startDate}&end=${this.endDate}`,
          {
            ...configObject.authConfig({ isRemis: true }),
            responseType: "blob",
          }
        )
        .then((response) => {
          // handle file download
          const contentDisposition = response.headers["content-disposition"];
          console.log(contentDisposition, response.headers, "jjj");

          let fileName = `Retainership-report(${this.startDate}-${this.endDate}).xls`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (fileNameMatch != null && fileNameMatch[1]) {
              fileName = fileNameMatch[1].replace(/['"]/g, "");
            }
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); // or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.showLoader = false;
          this.closeDownloadReportModal();
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
